import React from 'react';
import Tratamentos from './Tratamento';
import TratamentosPendentes from './TratamentoSigor';
import Filter from '../../../Auxiliar/Filter';
import { useSelector } from 'react-redux';

const SelecionarJsTratamento = () => {
    const permission = useSelector(state => state.AppReducer.permissoes.sigor.acesso)

    const [search, setSearch] = React.useState(false)
    const [dateOf, setDateOf] = React.useState('')
    const [dateFor, setDateFor] = React.useState('')
    const [options, setOptions] = React.useState({
        tratamento: { value: true, label: 'Tratamentos Finalizadas', checked: true },
        tratamentoPendente: { value: false, label: 'Tratamentos Pendentes(SIGOR)', checked: false, disabled: !permission },
    })

    return (
        <div className="card">
            <div className="card-body" id="card">
                <div className="d-flex align-items-start">
                    <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>Tratamentos</h4>
                    <Filter setDateOf={setDateOf} setDateFor={setDateFor} options={options} setOptions={setOptions} setSearch={setSearch} />
                </div>
                <div>
                    <p style={{ fontSize: '1rem', color: 'black' }}>Aqui são listados os Tratamentos do sistema</p>
                </div>
                <div className="row">
                    {options.tratamento.value &&
                        <Tratamentos dateOf={dateOf} dateFor={dateFor} search={search} setSearch={setSearch} />}
                    {options.tratamentoPendente.value &&
                        <TratamentosPendentes dateOf={dateOf} dateFor={dateFor} search={search} setSearch={setSearch} />}
                </div>
            </div>
        </div>
    )
}

export default SelecionarJsTratamento